function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2-gegc{fill:#d53d53}\r\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "-fegGroup_14011"
}, /*#__PURE__*/React.createElement("g", {
  id: "-fegSubtraction_8",
  fill: "#fff",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.557 23.685H14.8c-.27-.63-.9-1.072-1.631-1.072-.73 0-1.359.441-1.63 1.07l-1.129.002c-.27-.63-.9-1.072-1.63-1.072-.73 0-1.359.441-1.63 1.07l-1.129.002c-.27-.63-.9-1.072-1.63-1.072-.731 0-1.36.441-1.63 1.07l-.762.002c-.715 0-1.298-.583-1.298-1.3V2.002C.7 1.283 1.283.7 2 .7h.726c.25.672.902 1.153 1.663 1.153.762 0 1.413-.48 1.663-1.153h1.063c.25.672.902 1.153 1.664 1.153.761 0 1.412-.48 1.663-1.153h1.063c.25.672.901 1.153 1.663 1.153S14.58 1.373 14.83.7h.726c.717 0 1.3.583 1.3 1.3v20.386c0 .716-.583 1.3-1.3 1.3z",
  transform: "rotate(45 8.621 20.814)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1b1464",
  d: "M1.996 22.986l.354-.002c.446-.646 1.194-1.071 2.04-1.071.844 0 1.592.424 2.038 1.07h.312c.446-.646 1.194-1.07 2.039-1.07.845 0 1.592.424 2.039 1.07h.311c.447-.646 1.194-1.07 2.039-1.07.846 0 1.594.425 2.04 1.073h.35c.33 0 .6-.27.6-.6V2c0-.332-.27-.601-.6-.601h-.297c-.438.692-1.213 1.153-2.093 1.153-.88 0-1.655-.46-2.093-1.153h-.203c-.439.692-1.213 1.153-2.093 1.153-.88 0-1.655-.46-2.093-1.153h-.204c-.438.692-1.212 1.153-2.093 1.153-.88 0-1.654-.46-2.093-1.153H2c-.33 0-.6.27-.6.6v20.386c0 .33.27.6.596.6m13.561 1.4h-1.316v-.01c0-.586-.482-1.063-1.073-1.063-.592 0-1.073.477-1.073 1.063v.006l-2.244.003v-.009c0-.586-.48-1.063-1.072-1.063-.592 0-1.073.477-1.073 1.063v.006l-2.244.003v-.009c0-.586-.481-1.063-1.073-1.063-.591 0-1.073.477-1.073 1.063v.006L2 24.385c-1.103 0-2-.897-2-2V2.002C0 .898.897 0 2 0h1.32c-.002.028-.004.056-.004.09 0 .586.482 1.063 1.073 1.063.592 0 1.073-.477 1.073-1.064 0-.03-.001-.06-.004-.089H7.71c-.003.028-.004.056-.004.09 0 .586.481 1.063 1.073 1.063.591 0 1.072-.477 1.072-1.064 0-.03 0-.06-.003-.089h2.25c-.001.028-.003.056-.003.09 0 .586.481 1.063 1.073 1.063.591 0 1.073-.477 1.073-1.064 0-.029-.002-.059-.004-.089h1.32c1.103 0 2 .898 2 2v20.386c0 1.102-.897 2-2 2z",
  transform: "rotate(45 8.621 20.814)"
})), /*#__PURE__*/React.createElement("g", {
  id: "-fegGroup_4505",
  transform: "rotate(-45 15.865 -14.44)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "-fegEllipse_323",
  cx: 1.057,
  cy: 1.057,
  r: 1.057,
  className: "cls-2-gegc"
}), /*#__PURE__*/React.createElement("circle", {
  id: "-fegEllipse_324",
  cx: 1.057,
  cy: 1.057,
  r: 1.057,
  className: "cls-2-gegc",
  transform: "translate(0 4.306)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "-fegEllipse_325",
  cx: 1.057,
  cy: 1.057,
  r: 1.057,
  className: "cls-2-gegc",
  transform: "translate(0 8.611)"
})), /*#__PURE__*/React.createElement("rect", {
  id: "-fegRectangle_3532",
  width: 8.615,
  height: 2.128,
  className: "cls-2-gegc",
  rx: 1.064,
  transform: "rotate(-45 32.695 -3.247)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "-fegRectangle_3533",
  width: 8.615,
  height: 2.128,
  className: "cls-2-gegc",
  rx: 1.064,
  transform: "rotate(-45 27.7 -1.178)"
}));

var SvgHMoneyTravel = function SvgHMoneyTravel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.658,
    height: 29.658,
    viewBox: "0 0 29.658 29.658",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHMoneyTravel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/h-moneyTravel.d7cb6264.svg";
export { ForwardRef as ReactComponent };